import React, { useEffect, useState } from 'react';
import { platformApi } from '../../../api';
import {
  Typography,
  Input,
  Button,
  Dropdown,
  Menu,
  Icon,
  message,
  Tabs,
  DatePicker
} from "antd";
import CallLogsTable from './CallLogsTable';
import moment from 'moment';

const { Title } = Typography;
const { Search } = Input;
const { TabPane } = Tabs;

const CallLogs = () => {
  const [filters, setFilters] = useState({
    direction: "",
    status: "",
    searchString: "",
    fromDate: "",
    toDate: "",
    page: 1,
    size: 10
  });

  const [data, setData] = useState([]);
  const [count, setCount] = useState(0);
  const [limit, setLimit] = useState(10);
  const [spinning, setSpinning] = useState(false);

  const getData = (customFilters = filters) => {
    setData([]);
    setCount(null);
    setSpinning(true);
    platformApi
      .post(`/api/telecmi/phoneDialHistory`, customFilters)
      .then((response) => {

        setData(response.data.data || []);
        setCount(response.data.pagination?.totalRecords || 0);
      })
      .catch((err) => {
        message.error("Failed to fetch data");
      }).finally(() => {
        setSpinning(false);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  const handleTabChange = (key) => {
    setData([]);
    let direction = "";
    let status = "";

    if (key === "2") {
      direction = "inbound";
    } else if (key === "3") {
      direction = "outbound";
    } else if (key === "4") {
      status = "missed";
    }
    const updatedFilters = { ...filters, direction, status, page: 1 };
    setFilters(updatedFilters);
    getData(updatedFilters);
  };

  const menu = (
    <Menu onClick={({ key }) => setLimit(Number(key))}>
      {[10, 20, 30, 50].map((val) => (
        <Menu.Item key={val}>{val}</Menu.Item>
      ))}
    </Menu>
  );

  const handleDateChange = (date, dateString, type) => {
    const updatedFilters = { ...filters, [type]: dateString, page: 1 };
    setData([]);
    setFilters(updatedFilters);
    getData(updatedFilters);
  };

  const disabledFromDate = (current) => {
    if (!current) return false;
    const isFuture = current > moment().endOf('day');
    if (filters.toDate) {
      const toDate = moment(filters.toDate, 'YYYY-MM-DD');
      return isFuture || current > toDate.endOf('day');
    }
    return isFuture;
  };

  const disabledToDate = (current) => {
    if (!current) return false;
    const isFuture = current > moment().endOf('day');
    if (filters.fromDate) {
      const fromDate = moment(filters.fromDate, 'YYYY-MM-DD');
      return isFuture || current < fromDate.startOf('day');
    }
    return isFuture;
  };

  return (
    <div>
      <div className="accessories-head" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Title style={{ width: "60%" }} level={4}>
          Call Logs [{count}]
          <span style={{ margin: ".5rem" }}>
            <Dropdown overlay={menu} trigger={["click"]}>
              <Button>
                {limit} &nbsp;<Icon type="down" />
              </Button>
            </Dropdown>
          </span>
        </Title>
        <div style={{ display: 'flex', alignItems: 'center', width: "40%", justifyContent: 'space-between' }}>
          <Search
            style={{ width: "40%" }}
            placeholder="Search Number/Name"
            onSearch={(val) => {
              setData([]);
              const updatedFilters = { ...filters, searchString: val, page: 1 };
              setFilters(updatedFilters);
              getData(updatedFilters);
            }}
            allowClear
          />
          <DatePicker
            style={{ width: "25%" }}
            placeholder="From Date"
            disabledDate={disabledFromDate}
            onChange={(date, dateString) => handleDateChange(date, dateString, 'fromDate')}
            value={filters.fromDate ? moment(filters.fromDate, 'YYYY-MM-DD') : null}
          />
          <DatePicker
            style={{ width: "25%" }}
            placeholder="To Date"
            disabledDate={disabledToDate}
            onChange={(date, dateString) => handleDateChange(date, dateString, 'toDate')}
            value={filters.toDate ? moment(filters.toDate, 'YYYY-MM-DD') : null}
          />
        </div>
      </div>
      <Tabs defaultActiveKey="1" onChange={handleTabChange}>
        <TabPane tab="All Calls" key="1">
          <CallLogsTable data={data} paginationFilters={filters} setFilters={setFilters} limit={limit} total={count} spinner={spinning} />
        </TabPane>
        <TabPane tab="Incoming Calls" key="2">
          <CallLogsTable data={data} paginationFilters={filters} setFilters={setFilters} limit={limit} total={count} spinner={spinning} />
        </TabPane>
        <TabPane tab="Outgoing Calls" key="3">
          <CallLogsTable data={data} paginationFilters={filters} setFilters={setFilters} limit={limit} total={count} spinner={spinning} />
        </TabPane>
        <TabPane tab="Missed Calls" key="4">
          <CallLogsTable data={data} paginationFilters={filters} setFilters={setFilters} limit={limit} total={count} spinner={spinning} />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default CallLogs;